import * as types from './types';
import { round4 } from 'utilities/math';

import min from 'lodash/min';
import max from 'lodash/max';
import * as d3 from 'd3';

import { getFilteredParameterValuesNotEmpty } from 'store/dataset';
import { maxNumberOfBinsForHistogram } from 'utilities/validators';
const DEFAULT_THRESHOLDS = 9;
const DEFAULT_BIN_WIDTH = 1;

export const setActiveChartsAndGraphsTab = activeTab => ({
  type: types.SET_ACTIVE_CHARTS_AND_GRAPHS_TAB,
  activeTab
});

export const setBinWidth = binWidth => ({
  type: types.SET_BIN_WIDTH,
  binWidth
});

export const setMinBinWidth = minBinWidth => ({
  type: types.SET_MIN_BIN_WIDTH,
  minBinWidth
});

export const setStartingPoint = startPoint => ({
  type: types.SET_STARTING_POINT,
  startPoint
});

export const setMinStartingPoint = minStartPoint => ({
  type: types.SET_MIN_STARTING_POINT,
  minStartPoint
});

export const setBinWidthForParameter = parameterName => (dispatch, getState) => {
  const state = getState();
  const values = getFilteredParameterValuesNotEmpty(state, parameterName);

  const valuesDomain = d3.extent(values);
  let thresholds = d3.thresholdFreedmanDiaconis(values, ...valuesDomain);
  if (!thresholds || thresholds > maxNumberOfBinsForHistogram) {
    const range = max(values) - min(values);
    if (range < DEFAULT_THRESHOLDS) {
      thresholds = range + 1;
    } else {
      thresholds = DEFAULT_THRESHOLDS;
    }
  }

  let defaultBinWidth = (valuesDomain[1] - valuesDomain[0]) / thresholds;
  let minBinWidth = (valuesDomain[1] - valuesDomain[0]) / maxNumberOfBinsForHistogram;
  if (valuesDomain[1] === valuesDomain[0]) {
    defaultBinWidth = DEFAULT_BIN_WIDTH;
    minBinWidth = DEFAULT_BIN_WIDTH / maxNumberOfBinsForHistogram;
  }

  const startPoint = min(values);
  const minStartPoint = valuesDomain[1] - (maxNumberOfBinsForHistogram * defaultBinWidth);
  return dispatch([
    setBinWidth(round4(defaultBinWidth)),
    setMinBinWidth(round4(minBinWidth)),
    setMinStartingPoint(round4(minStartPoint)),
    setStartingPoint(startPoint)
  ]);
};
